import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.bike.link');
import { OnInit, OnDestroy } from '@angular/core';
import * as L from 'leaflet';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-bike-link',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.bike.link/view.scss */
:host {
  display: block;
  background: #f5f8fc;
  color: #18314f;
  min-height: 100%;
  font-family: Inter, "Noto Sans KR", sans-serif;
}

.bike-page {
  max-width: 1440px;
  margin: 0 auto;
  padding: 32px 34px 72px;
}

.bike-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  padding: 28px 30px;
  background: #102d50;
  color: white;
  border-radius: 19px;
}

.bike-header h1 {
  margin: 4px 0;
  font-size: 28px;
  letter-spacing: -0.04em;
}

.eyebrow {
  color: #4795e8;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.14em;
  margin: 0;
}

.bike-header .eyebrow {
  color: #8fc7ff;
}

.subtitle {
  margin: 0;
  color: #bcd1e8;
  font-size: 13px;
}

.header-control {
  display: flex;
  align-items: center;
  gap: 14px;
}

.header-control label {
  font-size: 12px;
}

select, input {
  border: 1px solid #d4e1ee;
  border-radius: 9px;
  padding: 10px 12px;
  background: white;
  color: #1e3854;
  font: inherit;
  outline: none;
}

.header-control select {
  margin-left: 8px;
  min-width: 100px;
}

.source-pill {
  display: inline-block;
  border-radius: 999px;
  background: #e8f3ff;
  color: #1769ad;
  padding: 7px 11px;
  font-size: 11px;
  font-weight: 750;
  white-space: nowrap;
}

.bike-header .source-pill {
  background: #214d77;
  color: #cceaff;
}

.bike-nav {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  padding: 17px 0 27px;
}

.bike-nav button {
  border: 1px solid #d9e5f1;
  background: white;
  color: #5d7189;
  border-radius: 9px;
  padding: 11px 17px;
  cursor: pointer;
  font-weight: 700;
  font-size: 13px;
}

.bike-nav button.active, .bike-nav button:hover {
  background: #1d70c4;
  color: white;
  border-color: #1d70c4;
}

.section-heading {
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 20px;
  margin: 10px 0 22px;
}

.section-heading h2 {
  margin: 6px 0 4px;
  font-size: 27px;
  letter-spacing: -0.05em;
}

.section-heading p:not(.eyebrow) {
  margin: 0;
  color: #73859b;
  font-size: 13px;
}

.metric-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 18px;
}

.metric-card, .panel {
  background: white;
  border: 1px solid #e0eaf4;
  box-shadow: 0 3px 15px rgba(18, 58, 101, 0.04);
  border-radius: 15px;
}

.metric-card {
  padding: 21px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.metric-card span {
  color: #68809a;
  font-size: 12px;
  font-weight: 700;
}

.metric-card strong {
  color: #163c68;
  font-size: 28px;
  letter-spacing: -0.04em;
}

.metric-card strong.period {
  font-size: 15px;
  line-height: 1.4;
}

.metric-card small {
  color: #8b9aab;
  font-size: 11px;
}

.two-column {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 17px;
  margin-bottom: 18px;
}

.panel {
  padding: 22px;
  margin-bottom: 18px;
  min-width: 0;
}

.two-column .panel {
  margin-bottom: 0;
}

.panel h3 {
  margin: 0 0 12px;
  font-size: 17px;
  letter-spacing: -0.025em;
}

.panel-note, .observed {
  font-size: 11px;
  color: #8193a9;
}

.coverage {
  font-size: 12px;
  color: #5d738b;
  background: #eaf3fd;
  padding: 12px 15px;
  border-radius: 9px;
  line-height: 1.6;
}

.observed {
  margin: 11px 0 20px;
}

.bar-chart {
  display: flex;
  align-items: end;
  gap: 3px;
  height: 230px;
  padding: 15px 4px 22px;
  border-bottom: 1px solid #cbd9e7;
  background: linear-gradient(to top, #f8fbff, #fff);
}

.bar-item {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: center;
  position: relative;
}

.bar {
  width: 78%;
  min-width: 3px;
  max-width: 23px;
  border-radius: 4px 4px 0 0;
  background: linear-gradient(#61a6f0, #1d6fcb);
}

.bar-item span {
  position: absolute;
  top: 100%;
  margin-top: 5px;
  color: #8293a7;
  font-size: 10px;
}

.coordinate-map, .network-map {
  width: 100%;
  height: 255px;
  display: block;
  background: #f2f8ff;
  border: 1px solid #dceaf7;
  border-radius: 10px;
}

.coordinate-map {
  background-image: linear-gradient(135deg, #eff8ff, #e6f0f8);
}

.day-list {
  display: grid;
  gap: 12px;
  margin-top: 18px;
}

.day-row {
  display: grid;
  grid-template-columns: 96px 1fr 90px;
  align-items: center;
  gap: 12px;
  font-size: 12px;
}

.day-row strong {
  text-align: right;
}

.day-track {
  background: #e8f1fa;
  height: 10px;
  border-radius: 999px;
  overflow: hidden;
}

.day-fill {
  background: #2d82d8;
  height: 100%;
  border-radius: 999px;
}

.station-layout {
  display: grid;
  grid-template-columns: minmax(260px, 340px) minmax(0, 1fr);
  gap: 18px;
}

.search-line, .ask-line {
  display: flex;
  gap: 8px;
}

.search-line input, .ask-line input {
  flex: 1;
  min-width: 0;
}

.search-line button, .ask-line button {
  border: 0;
  border-radius: 9px;
  background: #1f73c7;
  color: white;
  padding: 10px 15px;
  cursor: pointer;
  font-weight: 700;
}

.station-list {
  max-height: 540px;
  overflow: auto;
  display: grid;
  gap: 4px;
}

.station-row {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  text-align: left;
  border: 0;
  border-radius: 8px;
  background: white;
  padding: 10px;
  cursor: pointer;
}

.station-row:hover, .station-row.selected {
  background: #eaf4ff;
}

.station-row strong {
  display: block;
  color: #173d69;
  font-size: 12px;
}

.station-row small {
  display: block;
  color: #8194aa;
  font-size: 10px;
  margin-top: 3px;
}

.station-row em {
  font-size: 11px;
  color: #2672bd;
  font-style: normal;
  white-space: nowrap;
}

.detail-metrics {
  display: flex;
  gap: 25px;
  flex-wrap: wrap;
}

.detail-metrics span {
  display: block;
  color: #8193a9;
  font-size: 11px;
}

.detail-metrics strong {
  display: block;
  margin-top: 6px;
  font-size: 19px;
}

.rank-row {
  display: flex;
  align-items: center;
  gap: 12px;
  border-top: 1px solid #edf2f7;
  padding: 12px 0;
  font-size: 12px;
}

.rank-row .rank {
  color: #9cb0c4;
  font-weight: 800;
  width: 20px;
}

.rank-row strong {
  flex: 1;
}

.rank-row em {
  color: #246db8;
  font-weight: 800;
  font-style: normal;
}

.compare-controls {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;
}

.compare-controls label {
  color: #61758d;
  font-size: 12px;
  font-weight: 700;
}

.compare-controls select {
  margin-left: 8px;
}

.compare-card .big-number {
  display: block;
  color: #1f6eb9;
  font-size: 30px;
  margin: 18px 0 4px;
}

.compare-card p {
  color: #6c8199;
  font-size: 12px;
  line-height: 1.5;
}

.agent-panel {
  max-width: 850px;
  margin: auto;
}

.agent-intro {
  text-align: center;
  padding: 25px 0;
}

.agent-icon {
  display: inline-grid;
  place-items: center;
  background: #e8f4ff;
  color: #1e74c8;
  width: 54px;
  height: 54px;
  border-radius: 15px;
  font-size: 29px;
}

.agent-intro h3 {
  margin: 13px 0 5px;
}

.agent-intro p {
  font-size: 12px;
  color: #8495a8;
}

.ask-line button:disabled {
  opacity: 0.5;
  cursor: default;
}

.answer {
  border-top: 1px solid #e7eef6;
  margin-top: 23px;
  padding-top: 20px;
}

.answer p {
  white-space: pre-wrap;
  line-height: 1.7;
}

.answer h4 {
  font-size: 13px;
}

.answer details {
  border: 1px solid #e3edf7;
  border-radius: 9px;
  padding: 10px;
  margin: 7px 0;
  font-size: 12px;
}

.answer pre {
  overflow: auto;
  white-space: pre-wrap;
  background: #f7faff;
  padding: 10px;
}

.loading, .error, .empty {
  padding: 13px 15px;
  border-radius: 9px;
  font-size: 12px;
}

.loading, .empty {
  color: #687f98;
  background: #edf5fd;
}

.error {
  color: #b42318;
  background: #fff1f0;
  margin-bottom: 15px;
}

@media (max-width: 1050px) {
  .metric-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .two-column {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 700px) {
  .bike-page {
    padding: 18px 12px 44px;
  }
  .bike-header, .section-heading {
    display: block;
  }
  .header-control {
    margin-top: 18px;
    flex-wrap: wrap;
  }
  .metric-grid, .station-layout {
    grid-template-columns: 1fr;
  }
  .bike-nav {
    flex-wrap: nowrap;
    overflow-x: auto;
  }
  .bike-nav button {
    white-space: nowrap;
  }
  .day-row {
    grid-template-columns: 75px 1fr 70px;
  }
}
/* Reference-inspired dashboard, limited to measurements present in the data. */
.bike-header {
  background: linear-gradient(115deg, #0a2852, #143f78);
  box-shadow: 0 8px 24px rgba(13, 47, 91, 0.14);
}

.bike-nav {
  background: #102e58;
  border-radius: 11px;
  padding: 7px;
  margin: 10px 0 27px;
  gap: 4px;
}

.bike-nav button {
  border: 0;
  background: transparent;
  color: #c6d9ed;
}

.bike-nav button.active, .bike-nav button:hover {
  background: #2d65b1;
  color: #fff;
}

.dashboard-metrics {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.dashboard-metrics .metric-card {
  min-height: 112px;
  background: linear-gradient(120deg, #fff, #eaf4ff);
}

.dashboard-metrics .metric-card:nth-child(2) {
  background: linear-gradient(120deg, #fff, #e8f8f4);
}

.dashboard-metrics .metric-card:nth-child(3) {
  background: linear-gradient(120deg, #fff, #eeeaff);
}

.dashboard-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.8fr) minmax(280px, 1fr);
  gap: 16px;
  margin-bottom: 17px;
}

.dashboard-grid .panel {
  margin-bottom: 0;
}

.dashboard-side {
  display: grid;
  grid-template-rows: 1fr 1fr;
  gap: 16px;
}

.panel-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}

.panel-top h3 {
  margin-bottom: 2px;
}

.map-legend {
  color: #246ebc;
  font-size: 11px;
  font-weight: 750;
  white-space: nowrap;
}

.leaflet-map {
  height: 430px;
  border: 1px solid #d6e6f5;
  border-radius: 11px;
  overflow: hidden;
  background: #e6f0f7;
  z-index: 0;
}

.flow-list {
  display: grid;
  gap: 12px;
  margin-top: 18px;
}

.flow-label {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  font-size: 11px;
}

.flow-label strong {
  color: #1b3e65;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.flow-label em {
  color: #246dbc;
  font-style: normal;
  font-weight: 750;
  white-space: nowrap;
}

.flow-track {
  height: 7px;
  background: #e6eff9;
  border-radius: 9px;
  margin-top: 5px;
  overflow: hidden;
}

.flow-fill {
  height: 100%;
  background: linear-gradient(90deg, #97baff, #3269ca);
  border-radius: 9px;
}

.dashboard-side .rank-row {
  padding: 9px 0;
}

.dashboard-bottom .bar-chart {
  height: 200px;
}

.dashboard-bottom .day-list {
  min-height: 170px;
  justify-content: center;
}

@media (max-width: 1100px) {
  .dashboard-grid {
    grid-template-columns: 1fr;
  }
  .dashboard-side {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto;
  }
}
@media (max-width: 700px) {
  .dashboard-metrics {
    grid-template-columns: 1fr;
  }
  .dashboard-side {
    grid-template-columns: 1fr;
  }
  .leaflet-map {
    height: 340px;
  }
}
/* Full dashboard composition from the supplied reference. */
:host {
  height: 100%;
  min-height: 100%;
  background: #fff;
  color: #10264a;
}

.bike-page {
  display: flex;
  flex-direction: column;
  max-width: none;
  min-height: 0;
  height: 100%;
  padding: 0;
  margin: 0;
  background: #f7fbff;
}

.bike-header {
  flex: 0 0 84px;
  height: 84px;
  display: grid;
  grid-template-columns: 285px minmax(0, 1fr);
  align-items: center;
  gap: 0;
  padding: 0 18px;
  border-radius: 0;
  background: linear-gradient(105deg, #092c62, #13254e 85%);
  box-shadow: none;
}

.brand-area {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.brand-cycle {
  width: 56px;
  height: 44px;
  flex: 0 0 56px;
  color: #e4f3ff;
}

.brand-area strong {
  display: block;
  font-size: 20px;
  color: #fff;
  white-space: nowrap;
  letter-spacing: -0.02em;
}

.brand-area span {
  display: inline-block;
  border: 1px solid #8ba9d1;
  color: #e5f0ff;
  border-radius: 999px;
  padding: 1px 11px;
  font-size: 12px;
  margin-top: 3px;
}

.title-area {
  border-left: 1px solid rgba(222, 238, 255, 0.65);
  padding-left: 20px;
  min-width: 0;
}

.title-area h1 {
  color: #fff;
  font-size: 20px;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.title-area p {
  color: #c8d8ed;
  font-size: 12px;
  margin: 4px 0 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.bike-workspace {
  display: grid;
  grid-template-columns: 182px minmax(0, 1fr);
  flex: 1;
  min-height: 0;
}

.bike-sidebar {
  background: linear-gradient(170deg, #163b75, #11264d);
  color: #ecf4ff;
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: 11px 8px 20px;
}

.bike-nav {
  display: grid;
  gap: 4px;
  background: transparent;
  padding: 0;
  margin: 0;
  border-radius: 0;
}

.bike-nav button {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px 11px;
  text-align: left;
  border: 0;
  color: #edf4ff;
  background: transparent;
  font-size: 13px;
  border-radius: 7px;
  white-space: nowrap;
}

.bike-nav button.active, .bike-nav button:hover {
  background: linear-gradient(90deg, #4178c8, #3465ad);
  box-shadow: inset 3px 0 #a8d6ff;
}

.nav-icon {
  display: inline-grid;
  place-items: center;
  width: 19px;
  height: 20px;
  flex: 0 0 19px;
  font-size: 19px;
  line-height: 1;
}

.sidebar-rule {
  height: 1px;
  background: #6483b0;
  margin: 19px 11px 21px;
}

.sidebar-section {
  margin: 0 5px 22px;
}

.sidebar-section h2 {
  margin: 0 7px 10px;
  color: #e8f2ff;
  font-size: 13px;
  font-weight: 800;
}

.city-option {
  display: flex;
  align-items: center;
  gap: 9px;
  width: 100%;
  background: transparent;
  border: 0;
  padding: 8px 7px;
  color: #dfeafa;
  text-align: left;
  border-radius: 7px;
  font-size: 12px;
  font-weight: 750;
}

.city-option.selected {
  background: #f5f8ff;
  color: #172f55;
}

.city-check {
  width: 15px;
  height: 15px;
  border: 1px solid #a7b9d1;
  background: #fff;
  color: #fff;
  border-radius: 3px;
  line-height: 14px;
  text-align: center;
  font-size: 12px;
}

.city-option.selected .city-check {
  background: #337df7;
  border-color: #337df7;
  color: white;
}

.period-box {
  background: #f5f8ff;
  color: #243756;
  border-radius: 7px;
  padding: 9px 8px;
  font-size: 10px;
  font-weight: 750;
  text-align: center;
  line-height: 1.4;
}

.period-note {
  color: #9fb8dc;
  font-size: 10px;
  text-align: center;
  margin: 7px 0;
}

.sidebar-foot {
  margin-top: auto;
  padding: 0 8px;
  color: #9fb6d5;
  font-size: 10px;
  line-height: 1.5;
}

.sidebar-foot span {
  color: #5bdbb7;
  margin-right: 5px;
}

.bike-content {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  padding: 10px 13px 20px;
  background: linear-gradient(#f7fbff, #fff);
}

.dashboard-metrics {
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
  margin: 0 0 13px;
}

.dashboard-metrics .metric-card {
  height: 104px;
  min-height: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 16px;
  border: 0;
  border-radius: 10px;
  box-shadow: none;
}

.metric-blue {
  background: linear-gradient(110deg, #e4f2ff, #d8e8ff) !important;
}

.metric-mint {
  background: linear-gradient(110deg, #e0f9f5, #daf5f4) !important;
}

.metric-coral {
  background: linear-gradient(110deg, #fff0e9, #ffe7e4) !important;
}

.metric-purple {
  background: linear-gradient(110deg, #ede8ff, #e9e6ff) !important;
}

.dashboard-metrics .metric-card span:not(.metric-icon) {
  display: block;
  color: #183258;
  font-size: 14px;
  font-weight: 800;
  white-space: nowrap;
}

.dashboard-metrics .metric-card strong {
  display: block;
  color: #10264c;
  font-size: 25px;
  margin: 5px 0 1px;
  white-space: nowrap;
}

.dashboard-metrics .metric-card small {
  color: #536883;
  font-size: 10px;
  white-space: nowrap;
}

.metric-icon {
  flex: 0 0 36px;
  display: grid;
  place-items: center;
  font-size: 26px;
  line-height: 1;
  color: #347cf4;
}

.metric-mint .metric-icon {
  color: #20bf86;
}

.metric-coral .metric-icon {
  color: #ed6a5e;
}

.metric-purple .metric-icon {
  color: #7054d8;
}

.dashboard-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.7fr) minmax(320px, 1fr);
  gap: 12px;
  margin-bottom: 14px;
}

.dashboard-grid .panel {
  margin: 0;
  border: 1px solid #b8c9e3;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(15, 48, 96, 0.06);
}

.map-panel {
  position: relative;
  padding: 0 !important;
  min-height: 446px;
  overflow: hidden;
}

.leaflet-map {
  width: 100%;
  height: 446px;
  min-height: 446px;
  border: 0;
  border-radius: 0;
  z-index: 0;
}

.map-title {
  position: absolute;
  z-index: 550;
  top: 10px;
  left: 12px;
  background: #173562;
  color: #fff;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 16px;
  font-weight: 800;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.14);
}

.map-key {
  position: absolute;
  z-index: 550;
  bottom: 16px;
  left: 12px;
  display: grid;
  gap: 7px;
  background: rgba(255, 255, 255, 0.94);
  border-radius: 9px;
  border: 1px solid #dae6f3;
  padding: 11px 12px;
  color: #22395c;
  font-size: 11px;
  box-shadow: 0 3px 8px rgba(10, 40, 78, 0.12);
}

.map-key strong {
  font-size: 12px;
}

.map-key small {
  color: #657c99;
  font-size: 10px;
}

.map-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  background: #3c9bec;
  border: 2px solid #0f5ba8;
  border-radius: 50%;
  margin-right: 6px;
}

.dashboard-side {
  display: grid;
  grid-template-rows: 1fr 1fr;
  gap: 10px;
  min-height: 446px;
}

.dashboard-side .panel {
  overflow: hidden;
  padding: 12px 14px;
}

.dashboard-side h3 {
  background: #183562;
  color: #fff;
  border-radius: 7px;
  padding: 6px 10px;
  margin: -6px -8px 4px;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.panel-icon {
  margin-right: 6px;
  color: #d9e8ff;
}

.dashboard-side .panel-note {
  margin: 3px 0;
  color: #59708c;
  font-size: 10px;
}

.flow-panel {
  min-height: 0;
}

.od-diagram {
  width: 100%;
  height: 140px;
  display: block;
}

.priority-row {
  display: grid;
  grid-template-columns: 22px minmax(65px, 1.1fr) minmax(70px, 1fr) 47px;
  align-items: center;
  gap: 6px;
  height: 27px;
  border-top: 1px solid #e3eaf5;
  font-size: 10px;
}

.priority-row .place {
  display: grid;
  place-items: center;
  width: 18px;
  height: 18px;
  background: #dce5f4;
  border-radius: 50%;
  color: #243a5a;
  font-weight: 800;
}

.priority-row:first-of-type .place {
  background: #ffca35;
}

.priority-row strong {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.priority-row em {
  text-align: right;
  font-style: normal;
  font-weight: 800;
}

.priority-track {
  background: #edf1f7;
  height: 10px;
  border-radius: 2px;
  overflow: hidden;
}

.priority-fill {
  height: 100%;
  background: linear-gradient(90deg, #f5a0ab, #f16c82);
}

.analysis-strip {
  display: grid;
  grid-template-columns: repeat(5, minmax(235px, 1fr));
  gap: 7px;
  overflow-x: auto;
  padding-bottom: 3px;
}

.analysis-card {
  min-height: 280px;
  box-sizing: border-box;
  padding: 9px 10px;
  border-radius: 9px;
  border: 1px solid #c8d7ee;
  margin: 0;
  overflow: hidden;
}

.analysis-card h3 {
  margin: 0;
  font-size: 12px;
  color: #162b51;
  white-space: nowrap;
}

.analysis-card .panel-note {
  margin: 5px 0 10px;
  font-size: 10px;
}

.analysis-foot {
  margin: 9px 0 0;
  color: #6d819b;
  font-size: 10px;
}

.heatmap {
  display: grid;
  gap: 6px;
  margin-top: 24px;
}

.heatmap-row {
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr);
  align-items: center;
  gap: 4px;
  font-size: 10px;
  font-weight: 750;
}

.heat-cells {
  display: grid;
  grid-template-columns: repeat(24, minmax(0, 1fr));
  gap: 1px;
  height: 38px;
}

.heat-cell {
  display: block;
  border-radius: 1px;
}

.heat-hours {
  display: flex;
  justify-content: space-between;
  padding-left: 42px;
  font-size: 9px;
  color: #68809c;
}

.scatter {
  width: 100%;
  height: 175px;
  background: #fff;
}

.degree-row {
  display: grid;
  grid-template-columns: 58px 1fr;
  gap: 6px;
  align-items: center;
  margin: 8px 0;
  font-size: 10px;
}

.degree-row > span {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.degree-bars {
  display: grid;
  gap: 2px;
  height: 21px;
}

.degree-bars i {
  display: block;
  height: 9px;
  border-radius: 2px;
  background: #85bbf6;
}

.degree-bars i + i {
  background: #a68cf2;
}

.mini-city {
  display: grid;
  grid-template-columns: 35px 1fr 60px;
  gap: 5px;
  align-items: center;
  font-size: 10px;
  margin: 17px 0;
}

.mini-city strong {
  text-align: right;
}

.mini-track {
  height: 16px;
  background: #ecf0f8;
}

.mini-track div {
  height: 100%;
  background: #4c9af1;
}

.mini-city:nth-of-type(2) .mini-track div {
  background: #9c84eb;
}

.ai-mini {
  background: linear-gradient(#f3f5ff, #fff);
}

.ai-callout {
  display: flex;
  align-items: flex-start;
  gap: 7px;
  background: #fff;
  border: 1px solid #d3dcf0;
  border-radius: 8px;
  padding: 10px 8px;
  margin: 14px 0;
}

.ai-callout p {
  margin: 0;
  font-size: 10px;
  line-height: 1.5;
}

.ai-symbol {
  display: grid;
  place-items: center;
  width: 24px;
  height: 24px;
  flex: 0 0 24px;
  border-radius: 50%;
  color: #574dd2;
  background: #dddfff;
}

.ai-mini h4 {
  margin: 10px 0 5px;
  font-size: 10px;
  background: #dce5fa;
  padding: 4px;
}

.ai-mini > p {
  margin: 5px 0;
  font-size: 10px;
}

.ai-mini button {
  border: 0;
  border-radius: 6px;
  background: #495ec2;
  color: white;
  font-size: 10px;
  padding: 5px 8px;
  margin-top: 5px;
}

.dashboard-disclaimer {
  text-align: right;
  font-size: 10px;
  color: #66788f;
  margin: 9px 4px 0;
}

.bike-content > section {
  flex: 1 1 0;
  min-height: 0;
  width: 100%;
  max-width: none;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  overflow: auto;
}

.bike-content > section .agent-panel {
  max-width: none;
  margin: 0;
}

@media (max-width: 1380px) {
  .bike-header {
    grid-template-columns: 245px minmax(0, 1fr);
  }
  .brand-area strong {
    font-size: 17px;
  }
  .dashboard-metrics .metric-card {
    padding: 12px 10px;
  }
  .dashboard-metrics .metric-card strong {
    font-size: 21px;
  }
  .metric-icon {
    flex-basis: 25px;
    font-size: 20px;
  }
}
@media (max-width: 1060px) {
  .bike-header {
    grid-template-columns: 210px minmax(0, 1fr);
  }
  .dashboard-grid {
    grid-template-columns: 1fr;
  }
  .dashboard-side {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto;
    min-height: 0;
  }
  .dashboard-metrics {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 700px) {
  .bike-page {
    height: 100%;
    min-height: 0;
  }
  .bike-header {
    flex: 0 0 auto;
    height: auto;
    min-height: 84px;
    grid-template-columns: 1fr;
    padding: 12px;
  }
  .title-area {
    border: 0;
    padding: 8px 0 0;
  }
  .title-area h1 {
    font-size: 15px;
  }
  .bike-workspace {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: auto minmax(0, 1fr);
  }
  .bike-sidebar {
    min-width: 0;
    padding: 7px;
  }
  .bike-nav {
    display: flex;
    overflow: auto;
  }
  .bike-nav button {
    width: auto;
    min-width: max-content;
  }
  .sidebar-rule, .sidebar-section, .sidebar-foot {
    display: none;
  }
  .bike-content {
    display: flex;
    overflow: hidden;
    padding: 8px;
  }
  .dashboard-metrics {
    grid-template-columns: repeat(2, 1fr);
    gap: 6px;
  }
  .dashboard-metrics .metric-card {
    min-height: 88px;
  }
  .dashboard-metrics .metric-card strong {
    font-size: 17px;
  }
  .dashboard-side {
    grid-template-columns: 1fr;
  }
  .map-panel, .leaflet-map {
    min-height: 330px;
    height: 330px;
  }
  .map-title {
    font-size: 12px;
  }
}`],
})
export class ComponentBikeLinkComponent implements OnInit, OnDestroy {
    public tab = 'dashboard';
    public regionId = 'seoul';
    public regions: any[] = [];
    public overview: any = null;
    public dashboardNetwork: any = null;
    public dashboardRank: any = null;
    public dashboardExtra: any = null;
    public heatMax = 1;
    public stations: any[] = [];
    public stationTotal = 0;
    public stationSearch = '';
    public selectedStation: any = null;
    public network: any = null;
    public centrality: any = null;
    public compare: any = null;
    public compareA = 'seoul';
    public compareB = 'daejeon';
    public question = '';
    public answer: any = null;
    public busy = false;
    public error = '';
    public graphNodes: any[] = [];
    public graphEdges: any[] = [];
    private map: L.Map | null = null;
    private generation = 0;

    constructor(@Inject( Service) public service: Service) {}

    async ngOnInit() {
        await this.service.init();
        try {
            const result = await this.request('regions');
            this.regions = result.regions || [];
        } catch (error: any) {
            this.error = error.message;
        }
        await this.loadTab();
    }

    ngOnDestroy() { this.map?.remove(); this.map = null; }

    private async request(action: string, extra: any = {}) {
        const response: any = await wiz.call('handle', { action, region_id: this.regionId, ...extra });
        if (response.code !== 200) throw new Error(response.data?.message || response.message || '분석 데이터를 불러오지 못했습니다.');
        return response.data;
    }

    public async changeTab(tab: string) {
        if (!['dashboard', 'stations', 'network', 'regions', 'agent'].includes(tab)) return;
        if (tab !== 'dashboard') { this.map?.remove(); this.map = null; }
        this.tab = tab;
        await this.loadTab();
    }

    public async selectRegion(regionId: string) {
        this.regionId = regionId;
        await this.changeRegion();
    }

    public async changeRegion() {
        this.map?.remove(); this.map = null;
        this.stationSearch = '';
        this.selectedStation = null;
        await this.loadTab();
    }

    public async loadTab() {
        const current = ++this.generation;
        this.busy = true;
        this.error = '';
        try {
            if (this.tab === 'dashboard') {
                this.overview = null;
                this.dashboardNetwork = null;
                this.dashboardRank = null;
                this.dashboardExtra = null;
                const [result, network, rank, extra] = await Promise.all([
                    this.request('overview'), this.request('network'),
                    this.request('centrality'), this.request('dashboard_extra')
                ]);
                if (current !== this.generation) return;
                this.overview = result;
                this.dashboardNetwork = network;
                this.makeGraph(network, 7);
                this.dashboardRank = rank;
                this.dashboardExtra = extra;
                this.prepareDashboardExtra(extra);
            } else if (this.tab === 'stations') {
                const result = await this.request('stations', { query: this.stationSearch });
                if (current !== this.generation) return;
                this.stations = result.stations || [];
                this.stationTotal = result.total || 0;
            } else if (this.tab === 'network') {
                const result = await this.request('network');
                if (current !== this.generation) return;
                this.network = result;
                this.makeGraph(result);
                const rank = await this.request('centrality');
                if (current !== this.generation) return;
                this.centrality = rank;
            } else if (this.tab === 'regions') {
                const result = await this.request('compare');
                if (current !== this.generation) return;
                this.compare = result;
            }
        } catch (error: any) {
            if (current === this.generation) this.error = error.message;
        } finally {
            if (current === this.generation) {
                this.busy = false;
                await this.service.render();
                if (this.tab === 'dashboard' && this.overview) setTimeout(() => this.renderMap(), 0);
            }
        }
    }

    public async searchStations() {
        if (this.tab === 'stations') await this.loadTab();
    }

    public async openStation(station: any) {
        this.busy = true;
        this.error = '';
        try {
            this.selectedStation = await this.request('station', { station_id: station.station_id });
        } catch (error: any) {
            this.error = error.message;
        } finally {
            this.busy = false;
            await this.service.render();
        }
    }

    public async ask() {
        const message = this.question.trim();
        if (!message || this.busy) return;
        this.busy = true;
        this.error = '';
        this.answer = null;
        await this.service.render();
        try {
            this.answer = await this.request('chat', { message });
        } catch (error: any) {
            this.error = error.message;
        } finally {
            this.busy = false;
            await this.service.render();
        }
    }

    public hourBars(values: number[] | null) {
        if (!values?.length) return [];
        const max = Math.max(1, ...values);
        return values.map((value, hour) => ({ hour, value, height: Math.max(2, value / max * 100) }));
    }

    public dailyBars(items: any[]) {
        if (!items?.length) return [];
        const max = Math.max(1, ...items.map(item => item.rental_count || 0));
        return items.map(item => ({ ...item, height: Math.max(2, item.rental_count / max * 100) }));
    }

    public nameOf(regionId: string) {
        return this.regions.find(item => item.region_id === regionId)?.region_name || regionId;
    }

    public compareItem(regionId: string) {
        return this.compare?.regions?.find((item: any) => item.region_id === regionId);
    }

    public sourceLabel(item: any) {
        if (!item) return '자료 확인 중';
        if (item.verification_status === 'VERIFIED') return '공식 출처 확인 자료';
        if (item.verification_status === 'METADATA_ONLY') return '메타데이터만 확보';
        return '자료 미확보';
    }

    public periodLabel() {
        if (this.overview?.region_id !== this.regionId) return '지역별 확보 기간';
        return (this.overview.period_start || '기간 미확보') + ' ~ ' +
            (this.overview.period_end || '기간 미확보');
    }

    public heatColor(value: number) {
        const ratio = value / Math.max(1, this.heatMax);
        if (ratio > 0.78) return '#f45f65';
        if (ratio > 0.58) return '#ffc86d';
        if (ratio > 0.38) return '#e9ef98';
        if (ratio > 0.18) return '#78d8c5';
        return '#91c4f6';
    }

    public comparisonComparable() {
        const rows = this.dashboardExtra?.comparison || [];
        return rows.length === 2 && rows[0].observed_dates?.length > 0 &&
            JSON.stringify(rows[0].observed_dates) === JSON.stringify(rows[1].observed_dates);
    }

    public comparisonPercent(value: number) {
        const rows = this.dashboardExtra?.comparison || [];
        const maximum = Math.max(1, ...rows.map((row: any) => row.total_rentals || 0));
        return Math.max(3, value / maximum * 100);
    }

    private prepareDashboardExtra(extra: any) {
        this.heatMax = Math.max(1, ...(extra.heatmap || []).flatMap((row: any) => row.hours || []));
        const points = extra.cluster_points || [];
        if (!points.length) return;
        const xs = points.map((item: any) => item.x), ys = points.map((item: any) => item.y);
        const minX = Math.min(...xs), maxX = Math.max(...xs);
        const minY = Math.min(...ys), maxY = Math.max(...ys);
        extra.cluster_points = points.map((item: any) => ({
            ...item,
            px: 10 + (item.x - minX) / Math.max(0.001, maxX - minX) * 80,
            py: 88 - (item.y - minY) / Math.max(0.001, maxY - minY) * 76
        }));
    }

    public edgeName(id: string) {
        return this.dashboardNetwork?.nodes?.find((item: any) => item.station_id === id)?.station_name || id;
    }

    public rankPercent(value: number) {
        const maximum = this.dashboardRank?.rankings?.[0]?.pagerank || 1;
        return Math.max(3, value / maximum * 100);
    }

    public edgePercent(count: number) {
        const max = this.dashboardNetwork?.edges?.[0]?.trip_count || 1;
        return Math.max(5, count / max * 100);
    }

    private renderMap() {
        const element = document.getElementById('bike-leaflet-map');
        if (!element || this.tab !== 'dashboard') return;
        this.map?.remove();
        this.map = L.map(element, { scrollWheelZoom: false, zoomControl: true });
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; OpenStreetMap contributors',
            maxZoom: 19
        }).addTo(this.map);
        const rows = (this.overview?.map_stations || []).filter((item: any) =>
            Number.isFinite(item.latitude) && Number.isFinite(item.longitude));
        if (!rows.length) { this.map.setView([37.5665, 126.978], 10); return; }
        const bounds: L.LatLngTuple[] = [];
        for (const item of rows) {
            const point: L.LatLngTuple = [item.latitude, item.longitude];
            bounds.push(point);
            const caption = document.createElement('div');
            const name = document.createElement('strong');
            name.textContent = item.station_name || item.station_id;
            caption.appendChild(name);
            L.circleMarker(point, { radius: 5, color: '#0f5ba8', weight: 1.5,
                fillColor: '#3c9bec', fillOpacity: 0.8 }).addTo(this.map).bindPopup(caption);
        }
        this.map.fitBounds(L.latLngBounds(bounds).pad(0.12), { maxZoom: 12 });
        setTimeout(() => this.map?.invalidateSize(), 100);
    }

    private makeGraph(network: any, limit = 12) {
        const edges = (network?.edges || []).slice(0, limit);
        const ids = Array.from(new Set(edges.flatMap((item: any) => [item.origin_station_id, item.destination_station_id])));
        const names: any = {};
        for (const item of network?.nodes || []) names[item.station_id] = item.station_name || item.station_id;
        this.graphNodes = ids.map((id: any, index: number) => ({
            id, name: String(names[id] || id).split('_')[0].slice(0, 7),
            x: 50 + 35 * Math.cos(index * 2 * Math.PI / Math.max(1, ids.length)),
            y: 50 + 35 * Math.sin(index * 2 * Math.PI / Math.max(1, ids.length))
        }));
        const byId: any = {};
        for (const item of this.graphNodes) byId[item.id] = item;
        this.graphEdges = edges.map((item: any) => ({
            ...item, x1: byId[item.origin_station_id]?.x, y1: byId[item.origin_station_id]?.y,
            x2: byId[item.destination_station_id]?.x, y2: byId[item.destination_station_id]?.y
        }));
    }
}

export default ComponentBikeLinkComponent;